import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const Confire = () => {
     const [showModal, setShowModal] = useState(false)
     const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
     const handleOpenModal = (contentType, category, index, maxIndex) => {
         setModalContent({ contentType, category, index, maxIndex })
         setShowModal(true)
     }
     const handleCloseModal = () => {
         setModalContent({ contentType: '', category: '', index: 0 })
         setShowModal(false)
     }
    return (
        <>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-gadget-fr.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sm md:text-base text-shadow-white w-4/5 mx-auto mt-12'>
                <p> Vous n'êtes pas limité aux Combinages avec des roches ou des bouts de bois !</p>
                <p className='mt-4'>
                    Si Abricot se trouve à vos côtés, vous pourrez{' '}
                    <span className='text-pborange'>larguer des robots ou des chars</span>, voire même des véhicules
                    volants, nommés « <span className='text-pborange'>Gadgets</span> », avec lesquels vous pourrez vous
                    combiner !
                </p>{' '}
                <div className='flex mt-8'>
                    <div className='w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'gadget', 1)
                            }}
                            className='ss-thumb'
                            alt='game system gadget'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-gadget-1-s.webp`}
                        />
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Créer et renforcer vos Gadgets dans l'île du Squelette
                        </p>
                    </div>
                </div>{' '}
                <div className='flex mt-8'>
                    <div className='w-full md:w-3/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'gadget', 2)
                            }}
                            className='ss-thumb'
                            alt='screen shot of game scene'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-gadget-2-s.webp`}
                        />
                    </div>
                </div>{' '}
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='screen shot of game scene'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-mapgadget-fr.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                <p className='mt-4'>
                    Certaines cartes vous donneront accès à des <span className='text-pborange'>Gadgets spéciaux</span>,{' '}
                    comme des canons, des chars, des machines à sous ou des ventilateurs, qui vous permettront
                    d'effectuer des actions spéciales une fois combiné avec.{' '}
                    <span className='text-pborange'>La clef du succès</span> pour certaines cartes !
                </p>{' '}
                <div className='flex mt-8'>
                    <div className='w-full md:w-3/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'gadget', 3)
                            }}
                            className='ss-thumb'
                            alt='screen shot of game scene'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-gadget-3-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Des articles rares gagnés à la machine à sous ?
                        </p>
                    </div>
                </div>{' '}
            </div>{' '}
            {/* <div
                onClick={handleCloseModal}
                className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='w-full md:w-[80%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30'
                >
                    <div className='flex flex-row items-center mx-auto md:gap-4'>
                        <div className='relative'>
                            <button
                                onClick={handleCloseModal}
                                className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                            >
                                <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />{' '}
                            </button>
                            <img
                                className='white-drop-shadow max-w-[1920px] mx-auto w-full'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-gadget-${modalImage}.webp`}
                                alt='screen shot of game scene'
                            />{' '}
                        </div>
                    </div>
                </div>{' '}
            </div>{' '} */}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={3}
            />
        </>
    )
}
